// export const myGetter = (state) => {
    //Traen informacion del state y la procesan para retornarla
    // Reciben el state
    // return state
// }

export const defaultGet = (state) => {
    
}